
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/record-screen",
      function () {
        return require("private-next-pages/android/local/record-screen/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/record-screen"])
      });
    }
  